<template lang="pug">
.row
	
	.col-sm-6
		.widget
			.widget-header
				h2.title Data Control
			.widget-body
				.row
					.col-sm-12
						.form-group.mb-4
							label Distribution method
							select.form-control(v-model="offer.complex_distribution_method")
								option(v-for="option in complexDistributionMethodOptions", :value="option.v") {{ option.t }}

					.col-sm-12
						.d-flex.justify-content-between.w-100
							label Country
								i.la.la-info-circle.ml-1(v-b-tooltip.hover.right, title="When set to Auto - will use connected offers country")
							toggle-button(v-model="offer.lock_country", :labels="{checked: 'Manual', unchecked: 'Auto'}", :color="{checked: '#ffb047', unchecked: '#4a5cf2'}", :width="100", :height="24", :font-size="11")
						p.clearfix

					.col-sm-12(v-if="USER.config && USER.config.impressionRate")
						impratio(v-model="offer.impression_rate")

	.col-sm-6
		.widget
			.widget-header
				h2.title Caps
			.widget-body
				h3.widget-section-title Click & Conversion
				.form-group
					b-form-checkbox(v-model="offer.hide_caps") Hide caps
				h3.widget-section-title Frequency Cap
				frequency-cap(v-model="offer.frequency_cap_params")
</template>
<script>
export default {
	name: 'ComplexOfferDefaults',
	props: {
		offer: Object,
	},
	computed: {
		USER() {
			return this.$store.state.user;
		},
	},
	data() {
		return {
			complexDistributionMethodOptions: [
				{ v: 'weights', t: 'Weights' },
				{ v: 'first_active', t: 'First Active' },
				{ v: 'cr_priority', t: 'CR Priority' },
				{ v: 'auto', t: 'Auto' },
			],
		};
	},
};
</script>